import React, { useState } from "react";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwButton from "../../../shared/OwButton/OwButton";

type Props = {
    processedReport: IProcessed_Report;
};

export const CustomReport = (props: Props) => {
    const checkIfCsvData = () => {
        if (props.processedReport.report_data.csvData) {
            return true;
        } else {
            return false;
        }
    };

    const checkIfExcelData = () => {
        if (props.processedReport.report_data.excelBuffer) {
            return true;
        } else {
            return false;
        }
    };

    const [isCsvData, setIsCsvData] = useState(checkIfCsvData());
    const [isExcelData, setIsExcelData] = useState(checkIfExcelData());

    const downloadCsv = () => {
        const csvContent = "data:text/csv;charset=utf-8," + props.processedReport.report_data.csvData;

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `orderwerks-custom-report.csv`);

        link.click();
    };

    const downloadExcel = () => {
        const excelContent =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            props.processedReport.report_data.excelBuffer;

        const filename = props.processedReport.report_data.filename || `orderwerks-custom-report.xlsx`;

        const encodedUri = encodeURI(excelContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", filename);
        link.click();
    };

    return (
        <div className={"CustomReport"}>
            <div>
                <OwTitle title={props.processedReport.title} tag={"h3"} disableTranslation={true} />
            </div>
            {isCsvData ? <OwButton title={"download_csv"} fn={downloadCsv} /> : null}
            {isExcelData ? <OwButton title={"download_excel"} fn={downloadExcel} /> : null}
        </div>
    );
};
